import http from '@core/fetch'
export default {
  getAuthUrlApi: body =>
    http('/p/wedding/Admin/APIMerchantWeappAuth/AuthUrl', { body }),
  getAuthStatusApi: body =>
    http('/p/wedding/Admin/APIMerchantWeapp/Status', { body }),
  getConfigApi: () => http('/p/wedding/Admin/APIMerchantWeappVersion/Config'),
  getVersionListApi: () =>
    http('/p/wedding/Admin/APIMerchantWeappVersion/VersionList'),
  setConfigApi: body =>
    http.post('/p/wedding/Admin/APIMerchantWeappVersion/SaveConfig', { body }),
  cancelAuthApi: () =>
    http.post('/p/wedding/Admin/APIMerchantWeappAuth/CancelAuth'),
  submitAuditApi: body =>
    http.post('/p/wedding/Admin/APIMerchantWeappVersion/Submit', { body }),
  authConfirmApi: () =>
    http.post('/p/wedding/Admin/APIMerchantWeappAuth/AuthConfirm')
}
